import script from "./EmergencyMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./EmergencyMenu.vue?vue&type=script&setup=true&lang=js"

import "./EmergencyMenu.vue?vue&type=style&index=0&id=7a86c53e&scoped=true&lang=css"

import exportComponent from "F:\\Grupo Low Cost\\Aplicación Mallorca\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a86c53e"]])

export default __exports__